// src/hooks/useMigrationDate.js

import { useSelector, useDispatch } from "react-redux";
import { useEffect } from "react";
import { fetchSingleInstitutionDetails } from "../store/commonThunks/lookups";
import dayjs from "dayjs";

const useMigrationDate = () => {
  const dispatch = useDispatch();

  const migrationDate = useSelector(
    (state) => state.lookups?.institutionData?.migration_date
  );

  const transactionLockDate = useSelector(
    (state) => state.auth?.auth_info?.transaction_lock_date
  );

  useEffect(() => {
    if (!migrationDate) {
      dispatch(fetchSingleInstitutionDetails());
    }
  }, []);

  const disabledDate = (current) => {
    if (migrationDate) {
      if (current && current.isBefore(dayjs(migrationDate), "day")) {
        return true;
      }
    }
    if (transactionLockDate) {
      if (
        current &&
        current.isBefore(dayjs(transactionLockDate), "day")
      ) {
        return true;
      }
    }

    return false;
  };

  return { migrationDate, disabledDate };
};

export default useMigrationDate;